import { createSelector } from 'reselect';

const selectMessages = (state) => state.messages;
const selectToasts = createSelector(
	selectMessages,
	(messages) => messages.toasts
);

const messagesSelectors = {
	selectMessages,
	selectToasts,
};

export default messagesSelectors;
